<template>
  <el-upload
    action="#"
    :on-remove="handleRemove"
    :before-remove="beforeRemove"
    :http-request="handleUpload"
    :on-exceed="handleExceed"
    :limit="4"
    :accept="accepts"
    :file-list="fileList"
    :on-preview="handleDownload"
    :before-upload="beforeUpload"
  >
    <div class="label">
      <i class="el-icon-upload2" />
      <span> {{ $t('AttachmentUpload_Button_Upload') }} </span>
    </div>
  </el-upload>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'AttachmentUpload',
  mounted() {
    if (this.value[0].name) {
      this.fileList = this.value
    }
  },
  data() {
    return {
      fileList: []
    }
  },
  props: {
    value: {
      required: true
    },
    accepts: {
      required: false,
      type: String,
      default: '.pdf'
    }
  },

  computed: {
    fileValue: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleExceed(files) {
      this.$message({
        message: 'Failed to upload, maximum number of files reached.',
        type: 'error'
      })
    },
    handleUpload(option) {
      const formData = new FormData()
      formData.append('attachment', option.file)
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `campaigns/upload-attachment`,
          config: { headers: { 'Content-Type': 'multipart/form-data' } },
          data: formData
        })
      )
        .then(({ data }) => {
          this.fileList.push({ name: option.file.name, file: data.file })
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    handleDownload(file) {
      RestApi(
        projectEndpoint({
          method: 'get',
          url: `campaigns/download-attachment`,
          responseType: 'arraybuffer',
          params: file
        })
      )
        .then(({ data }) => {
          const blob = new Blob([data], { type: 'application/pdf' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = file.name
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    },
    beforeRemove(file) {
      return this.$confirm(
        this.$t('AttachmentUpload_DeletePrompt', { file: file.name })
      )
    },
    beforeUpload(file) {
      const maxSize = 500 * 1024 // 500kb
      if (file.size <= maxSize) {
        return true
      }
      this.handleRemove(file)
    }
  },
  watch: {
    fileList: {
      handler(value) {
        if (value.length > 0) {
          this.fileValue = value.map(item => {
            return {
              file: item.file,
              name: item.name
            }
          })
        } else {
          this.fileValue = [
            {
              file: '',
              name: null
            }
          ]
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
>>> .el-upload {
  width: 100%;
  border: 1px dashed #dbdee7;
  border-radius: 4px;
  color: #a6a6a6;
  font-size: 14px;
  position: relative;
  overflow: hidden;
  height: 38px;
}

>>> .el-upload:hover {
  background-color: #e6f3fb;
  border: 1px dashed #1d87c8;
  color: #1d87c8;
}

.label {
  padding-left: 40px;
  padding-right: 40px;
  line-height: 38px;
  white-space: nowrap;
}

.label i {
  margin-right: 6px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/form/AttachmentUpload.vue